import { Megaphone } from "lucide-react";

export const statusOptions = [
  {
    label: "Online",
    color: "#4DFF00",
    icon: "/icons/correct.png",
  },
  {
    label: "Away",
    color: "#FFA500",
    icon: "/icons/correct.png",
  },
  {
    label: "Do Not Disturb",
    color: "#FF0000",
    icon: "/icons/correct.png",
  },
];
export const sidebarItems1 = [
  { icon: "/icons/Dashboard.png", label: "Dashboard", path: "/" },
  { icon: "/icons/call.png", label: "Voice Calls", path: "/voice-calls" },

  { icon: "/icons/Chat.png", label: "Chat", path: "/chat" },
  {
    icon: <Megaphone color="white" size={18} />,
    label: "Collection Campaign",
    path: "/collection-campaign",
  },
  { icon: "/icons/Email.png", label: "Email Inbox", path: "/email-inbox" },
  { icon: "/icons/share.png", label: "Social Media", path: "/social-media" },
  {
    icon: "/icons/workflow.png",
    label: "Workflow Tasks",
    path: "/workflow-tasks",
  },
  {
    icon: "/icons/customer-profile.png",
    label: "CRM / Customer profile",
    path: "/crm",
  },
  {
    icon: "/icons/carbon_book.png",
    label: "Knowledge Base",
    path: "/knowledge-base",
  },
  { icon: "/icons/reports.png", label: "Reports", path: "/reports" },
];

export const actionButtons = [
  { icon: "/icons/mute.png", alt: "mute" },
  { icon: "/icons/pause.png", alt: "pause" },
  { icon: "/icons/add-person.png", alt: "Add person" },
  { icon: "/icons/call.png", alt: "call", isRed: true },
];

export const buttonLabels = [
  { label: "All Channels", path: "/" },
  { label: "Voice Calls", path: "/voice-calls" },
  { label: "Chats", path: "/chat" },
  { label: "Emails", path: "/email-inbox" },
  { label: "Social Media", path: "/social-media" },
  { label: "Collection Campaign", path: "/collection-campaign" },
];
export const buttonLabelCrm = [
  { label: "Overview", path: "" },
  { label: "Orders", path: "" },
  { label: "Interactions", path: "" },
  { label: "Support Tickets", path: "" },
  { label: "Customer Analytics", path: "" },
];
export const buttonLabelKnowledgeBase = [
  { label: "All Categories", path: "" },
  { label: "Getting Started", path: "" },
  { label: "Product Guide", path: "" },
  { label: "API documentation", path: "" },
  { label: "Best Practices", path: "" },
];

export const generateCardData = (summary) => [
  {
    label: "Active Chats",
    count: summary.activeChats,
    bgColor: "bg-[#DBEAFE]",
    icon: "/icons/blue-chat.png",
    trend: summary.trends.activeChats.startsWith("+") ? "up" : "down",
    trendValue: summary.trends.activeChats.replace("+", "").replace("-", ""),
    timeline: "from yesterday",
  },
  {
    label: "Pending Emails",
    count: summary.pendingEmails,
    bgColor: "bg-[#DCFCE7]",
    icon: "/icons/green-email.png",
    trend: summary.trends.pendingEmails.startsWith("+") ? "up" : "down",
    trendValue: summary.trends.pendingEmails.replace("+", "").replace("-", ""),
    timeline: "from yesterday",
  },
  {
    label: "Social Mentions",
    count: summary.socialMentions,
    bgColor: "bg-[#F3E8FF]",
    icon: "/icons/purple-shareit.png",
    trend: summary.trends.socialMentions.startsWith("+") ? "up" : "down",
    trendValue: summary.trends.socialMentions.replace("+", "").replace("-", ""),
    timeline: "from yesterday",
  },
  {
    label: "Avg. Response Time",
    count: summary.averageResponseTime,
    bgColor: "bg-[#FFEDD5]",
    icon: "/icons/orange-clock.png",
    trend: summary.trends.averageResponseTime.startsWith("+") ? "up" : "down",
    trendValue: summary.trends.averageResponseTime
      .replace("+", "")
      .replace("-", ""),
    timeline: "from yesterday",
  },
];

export const chatItems = (activeChats) =>
  activeChats.map((item, index) => ({
    name: item.name,
    time: item.timestamp,
    message: item.message,
    image:
      ["/icons/emily.png", "/icons/robert.png", "/icons/marcus.png"][index] ||
      "/icons/default.png",
    status: "available",
  }));

export const chatItems2 = (activeChats) =>
  activeChats.map((item, index) => ({
    id: item.id, // ✅ required for selecting chat
    name: item.name,
    time: item.time,
    message: item.message,
    image:
      item.customer?.avatar ||
      ["/icons/emily.png", "/icons/robert.png", "/icons/marcus.png"][index] ||
      "/icons/jessica.png",
    status: index % 2 === 0 ? "available" : "away",
  }));

export const voiceCallSummary = [
  {
    label: "Total Calls Today",
    count: 87,
    bgColor: "bg-[#DBEAFE]",
    icon: "/icons/blue-call.png",
    trend: "up",
    trendValue: "8%",
    timeline: "from yesterday",
  },

  {
    label: "Average Duration",
    count: "4m 32s",
    bgColor: "bg-[#FFEDD5]",
    icon: "/icons/orange-clock.png",
    trend: "down",
    trendValue: "3%",
    timeline: "from yesterday",
  },
  {
    label: "Active Calls",
    count: 12,
    bgColor: "bg-[#DCFCE7]",
    icon: "/icons/green-call.png",
    trend: "up",
    trendValue: "4",
    timeline: "from an hour ago",
  },
  {
    label: "Success Rate",
    count: "94.2%",
    bgColor: "bg-[#F0DFFF]",
    icon: "/icons/purple-tick.png",
    trend: "up",
    trendValue: "1.5%",
    timeline: "from yesterday",
  },
];

// Dummy data for rows
export const callLogData = [
  {
    caller: "Robert Johnson",
    date: "Wed 1:00pm",
    duration: "1:25",
    direction: "Inbound",
    issue: "Bill update",
    status: "Active",
    phone: "+1 2767840879",
    textColor: "#AA59F7",
  },
  {
    caller: "Anjali Verma",
    date: "Thu 11:15am",
    duration: "2:10",
    direction: "Outbound",
    issue: "Loan enquiry",
    status: "Resolved",
    phone: "+1 2767840879",
    textColor: "#4CFF00",
  },
  {
    caller: "Amit Patel",
    date: "Fri 9:30am",
    duration: "0:45",
    direction: "Inbound",
    issue: "UPI failure",
    status: "Escalated",
    phone: "+1 2767840879",
    textColor: "#FF630B",
  },
  {
    caller: "Robert Johnson",
    date: "Wed 1:00pm",
    duration: "1:25",
    direction: "Inbound",
    issue: "Bill update",
    status: "Active",
    phone: "+1 2767840879",
    textColor: "#AA59F7",
  },
  {
    caller: "Anjali Verma",
    date: "Thu 11:15am",
    duration: "2:10",
    direction: "Outbound",
    issue: "Loan enquiry",
    status: "Resolved",
    phone: "+1 2767840879",
    textColor: "#4CFF00", //    textColor: "text-[#AA59F7]",#4CFF00
  },
  {
    caller: "Amit Patel",
    date: "Fri 9:30am",
    duration: "0:45",
    direction: "Inbound",
    issue: "UPI failure",
    status: "Escalated",
    phone: "+1 2767840879",
    textColor: "#FF630B", //    textColor: "text-[#AA59F7]",#4CFF00
  },
  {
    caller: "Robert Johnson",
    date: "Wed 1:00pm",
    duration: "1:25",
    direction: "Inbound",
    issue: "Bill update",
    status: "Active",
    phone: "+1 2767840879",
    textColor: "#AA59F7",
  },
  {
    caller: "Anjali Verma",
    date: "Thu 11:15am",
    duration: "2:10",
    direction: "Outbound",
    issue: "Loan enquiry",
    status: "Resolved",
    phone: "+1 2767840879",
    textColor: "#4CFF00",
  },
  {
    caller: "Amit Patel",
    date: "Fri 9:30am",
    duration: "0:45",
    direction: "Inbound",
    issue: "UPI failure",
    status: "Escalated",
    phone: "+1 2767840879",
    textColor: "#FF630B",
  },
  {
    caller: "Robert Johnson",
    date: "Wed 1:00pm",
    duration: "1:25",
    direction: "Inbound",
    issue: "Bill update",
    status: "Active",
    phone: "+1 2767840879",
    textColor: "#AA59F7",
  },
  {
    caller: "Anjali Verma",
    date: "Thu 11:15am",
    duration: "2:10",
    direction: "Outbound",
    issue: "Loan enquiry",
    status: "Resolved",
    phone: "+1 2767840879",
    textColor: "#4CFF00",
  },
  {
    caller: "Amit Patel",
    date: "Fri 9:30am",
    duration: "0:45",
    direction: "Inbound",
    issue: "UPI failure",
    status: "Escalated",
    phone: "+1 2767840879",
    textColor: "#FF630B",
  },
];

export const customerActions = [
  { icon: "/icons/black-call.png", alt: "Call" },
  { icon: "/icons/black-chat.png", alt: "Message" },
  { icon: "/icons/black-email.png", alt: "Email" },
];

export const getCustomerDetails = (customerInfo) => [
  {
    label: "Email",
    value: customerInfo.email,
    icon: "/icons/black-email.png",
  },
  {
    label: "Phone",
    value: customerInfo.phone,
    icon: "/icons/black-call.png",
  },
  {
    label: "Company",
    value: "Thompson Enterprise",
    icon: "/icons/company.png",
  },
  {
    label: "Address",
    value: "221B Baker Street, London",
    icon: "/icons/location.png",
  },
  {
    label: "Customer Since",
    value: customerInfo.since,
    icon: "/icons/calender.png",
  },
  {
    label: "Total Orders",
    value: customerInfo.totalOrders,
    icon: "/icons/orders.png",
  },
];

export const emailFilterTabs = [
  {
    icon: "/icons/inbox.png",
    label: "Inbox",
    highlight: true,
  },
  {
    icon: "/icons/sent.png",
    label: "Sent",
    highlight: false,
  },
  {
    icon: "/icons/label.png",
    label: "Label",
    highlight: false,
  },
  {
    icon: "/icons/trash.png",
    label: "Trash",
    highlight: false,
  },
  {
    icon: "/icons/draft.png",
    label: "Draft",
    highlight: false,
  },
];

export const emailPreviewList = [
  {
    id: 1,
    subject: "Order Confirmation #87654",
    sender: "David Miller",
    message:
      "Thank you for your recent purchase. Your order #87654 has been confirmed and is being processed. You should receive...",
  },
  {
    id: 2,
    subject: "Welcome to Our Newsletter",
    sender: "Support Team",
    message:
      "We’re excited to have you! Stay tuned for weekly updates and exclusive offers just for you.",
  },
  {
    id: 3,
    subject: "Your Subscription Receipt",
    sender: "Billing Department",
    message:
      "This is a confirmation for your subscription payment. Download your receipt or manage your billing preferences.",
  },
  {
    id: 4,
    subject: "Password Reset Request",
    sender: "Security Team",
    message:
      "We received a request to reset your password. Click the link below to set a new password within the next 30 minutes.",
  },
  {
    id: 5,
    subject: "Upcoming Webinar Invitation",
    sender: "Marketing Team",
    message:
      "Join us this Friday for an exclusive webinar on how to maximize productivity with our new tools.",
  },
];

export const formatSocialMentions = (mentions) =>
  mentions.map((item, index) => ({
    username: item.user,
    message: item.comment,
    timestamp: item.timestamp,
    icon: ["/icons/insta.png", "/icons/fb.png"][index] || "/icons/default.png",
    bgColor: ["bg-[#FEDBF4]", "bg-[#DBEAFE]"][index] || "bg-gray-100",
  }));

export const customers = [
  {
    profileImg: "/icons/robert.png",
    name: "James Harrison",
    email: "robertjohn@example.com",
    badgeText: "Premium",
    badgeBg: "#E1FFD5",
    badgeTextColor: "#3FC904",
    lastContacted: "Today",
    amount: "$4231",
    borderColor: "#4CFF00",
  },
  {
    profileImg: "/icons/emily.png",
    name: "Mary Allen",
    email: "maryallen@example.com",
    badgeText: "Standard",
    badgeBg: "#DBEAFE",
    badgeTextColor: "#3B82F6",
    lastContacted: "2 days ago",
    amount: "$128",
    borderColor: "#ffff",
  },
  {
    profileImg: "/icons/jessica.png",
    name: "John Doe",
    email: "john.doe@example.com",
    badgeText: "Enterprices",
    badgeBg: "#F3E8FF",
    badgeTextColor: "#AA59F7",
    lastContacted: "Yesterday",
    amount: "$9043",
    borderColor: "#ffff",
  },
  {
    profileImg: "/icons/marcus.png",
    name: "Mary Allen",
    email: "maryallen@example.com",
    badgeText: "Standard",
    badgeBg: "#DBEAFE",
    badgeTextColor: "#3B82F6",
    lastContacted: "2 days ago",
    amount: "$128",
    borderColor: "#ffff",
  },
  {
    profileImg: "/icons/Profile-pic.png",
    name: "John Doe",
    email: "john.doe@example.com",
    badgeText: "New",
    badgeBg: "#FFFECB",
    badgeTextColor: "#E4E000",
    lastContacted: "Yesterday",
    amount: "$9043",
    borderColor: "#ffff",
  },
  {
    profileImg: "/icons/jessica.png",
    name: "John Doe",
    email: "john.doe@example.com",
    badgeText: "Enterprices",
    badgeBg: "#F3E8FF",
    badgeTextColor: "#AA59F7",
    lastContacted: "Yesterday",
    amount: "$9043",
    borderColor: "#ffff",
  },
];

export const gridItems = [
  { title: "Customer Since", subtext: "March 15, 2023" },
  { title: "Total Orders", subtext: "24" },
  { title: "Lifetime Value", subtext: "$4,250.00" },
  { title: "Last Purchase", subtext: "May 2, 2025" },
];

export const customerDetailCrm = [
  {
    icon: "/icons/crown.png",
    label: "Subscription Plan",
    value: "Premium (Annual)",
  },
  {
    icon: "/icons/calender.png",
    label: "Next Billing Date",
    value: "March 15, 2026",
  },
  {
    icon: "/icons/card.png",
    label: "Payment Method",
    value: "Visa ending in 4567",
  },
  {
    icon: "/icons/account.png",
    label: "Account Status",
    value: "Active",
  },
];

export const tableDetailsCrm = [
  {
    caller: "#ORD-7829",
    date: "Wed 1:00pm",
    duration: "Premium Headphones, Wireless Charger",
    direction: "$349.99",
    status: "Active",
    textColor: "#AA59F7",
  },
  {
    caller: "#ORD-7645",
    date: "Thu 11:15am",
    duration: "Smart Speaker, USB-C Cable (2)",
    direction: "$189.97",

    status: "Resolved",
    textColor: "#4CFF00",
  },
  {
    caller: "#ORD-7512",
    date: "Fri 9:30am",
    duration: "Laptop Sleeve, Wireless Mouse",
    direction: "$79.98",
    status: "Escalated",
    textColor: "#FF630B",
  },
];

// Sample data
export const featuredArticles = [
  {
    id: 1,
    image: "/icons/bg1.png",
    priority: "High Priority",
    readTime: "5 min read",
    title: "Complete Guide to the Virtual Contact Center",
    description:
      "Learn how to set up and optimize your virtual contact center for maximum performance.",
    author: {
      name: "James Wilson",
      role: "Senior Lead",
      avatar: "/icons/Profile-pic.png",
    },
  },
  {
    id: 2,
    image: "/icons/bg2.png",
    priority: "High Priority",
    readTime: "6 min read",
    title: "Improving Team Collaboration Remotely",
    description:
      "Tips and tools to enhance productivity and connection with remote teams.",
    author: {
      name: "Priya Sharma",
      role: "Project Manager",
      avatar: "/icons/Profile-pic.png",
    },
  },
  {
    id: 3,
    image: "/icons/bg3.png",
    priority: "High Priority",
    readTime: "4 min read",
    title: "Onboarding Employees Virtually: A New Normal",
    description:
      "Best practices to onboard and engage new hires in a virtual workspace.",
    author: {
      name: "Amit Verma",
      role: "HR Consultant",
      avatar: "/icons/Profile-pic.png",
    },
  },
];

export const reportChartSummary = [
  {
    label: "Average Handle Time",
    count: "4m 28s",
    bgColor: "bg-[#ffff]",
    icon: "/icons/icon.jpg",
    trend: "up",
    trendValue: "+12.5%",
    timeline: "from last month",
  },

  {
    label: "Queue Time",
    count: "42s",
    bgColor: "bg-[#ffff]",
    icon: "/icons/icon.jpg",
    trend: "down",
    trendValue: "8.3%",
    timeline: "from last month",
  },
  {
    label: "Abandonment Rate",
    count: "5.2%",
    bgColor: "bg-[#ffff]",
    icon: "/icons/icon.jpg",
    trend: "up",
    trendValue: "-2.1%",
    timeline: "from last month",
  },
  {
    label: "Service Level",
    count: "92.7%",

    bgColor: "bg-[#ffff]",
    icon: "/icons/icon.jpg",
    trend: "up",
    trendValue: "3.8%",
    timeline: "from last month",
  },
];

export const reportSummary = [
  {
    label: "Total Interactions",
    count: "8,742",
    sublabel: "Calls, chats, and emails",
    bgColor: "bg-[#DBEAFE]",
    icon: "/icons/headphones.png",
    trend: "up",
    trendValue: "+12.5%",
  },

  {
    label: "Average Response Time",
    count: "1m 42s",
    sublabel: "Across all channels",

    bgColor: "bg-[#DCFCE7]",

    icon: "/icons/green-clock.png",
    trend: "down",
    trendValue: "8.3%",
  },
  {
    label: "Customer Satisfaction",
    count: "4.7/5.0",
    sublabel: "Based on 2,156 ratings",

    bgColor: "bg-[#F0DFFF]",

    icon: "/icons/emoji.png",
    trend: "up",
    trendValue: "-2.1%",
  },
  {
    label: "First Contact Resolution",
    count: "78.3%",
    sublabel: "Issues resolved first time",

    bgColor: "bg-[#FFEDD5]",
    icon: "/icons/tick-double.png",
    trend: "up",
    trendValue: "3.8%",
  },
];
